<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Admin</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Admin
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">

                <div class="card-body">
                    <div class="form-body">
                        <h4 class="form-section"><i class="feather icon-user"></i> Personal Info</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="projectinput1">First Name</label>
                                    <input type="text" id="projectinput1" class="form-control" placeholder="First Name" name="fname">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="projectinput2">Last Name</label>
                                    <input type="text" id="projectinput2" class="form-control" placeholder="Last Name" name="lname">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="projectinput3">E-mail</label>
                                    <input type="text" id="projectinput3" class="form-control" placeholder="E-mail" name="email">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="projectinput4">Contact Number</label>
                                    <input type="text" id="projectinput4" class="form-control" placeholder="Phone" name="phone">
                                </div>
                            </div>
                        </div>

                        <h4 class="form-section"><i class="fa fa-paperclip"></i> Requirements</h4>

                        <div class="form-group">
                            <label for="companyName">Company</label>
                            <input type="text" id="companyName" class="form-control" placeholder="Company Name" name="company">
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="projectinput5">Interested in</label>
                                    <select id="projectinput5" name="interested" class="form-control">
                                        <option value="none" selected="" disabled="">Interested in</option>
                                        <option value="design">design</option>
                                        <option value="development">development</option>
                                        <option value="illustration">illustration</option>
                                        <option value="branding">branding</option>
                                        <option value="video">video</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="projectinput6">Budget</label>
                                    <select id="projectinput6" name="budget" class="form-control">
                                        <option value="0" selected="" disabled="">Budget</option>
                                        <option value="less than 5000$">less than 5000$</option>
                                        <option value="5000$ - 10000$">5000$ - 10000$</option>
                                        <option value="10000$ - 20000$">10000$ - 20000$</option>
                                        <option value="more than 20000$">more than 20000$</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Select File</label>
                            <label id="projectinput7" class="file center-block">
                                <input type="file" id="file">
                                <span class="file-custom"></span>
                            </label>
                        </div>

                        <div class="form-group">
                            <label for="projectinput8">About Project</label>
                            <textarea id="projectinput8" rows="5" class="form-control" name="comment" placeholder="About Project"></textarea>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Create Admin'},
    name: 'AdminCreate',
    props: ['isEditing', 'posts'],
    layout: Layout,
    // components: {
    //     VueEditor,
    //     FilePond,
    //     ValidationErrors
    // },
    data: () => ({
        post: {
            type: ''
        },
        saving: false,
        blogImage: [],
    }),
    methods: {
        async createBlog() {
            this.saving = true;
            let vm = this;

            try {
                const formData = new FormData();
                const uploadedFiles = this.$refs.blogImage.getFiles();

                if (uploadedFiles.length > 0) {
                    uploadedFiles.forEach(file => formData.append('image', file.file));
                }
                // add post key value pair
                Object.keys(this.post).forEach(post => formData.append(post, this.post[post]));

                this.$inertia.post(route('cms.blogs'), formData, {
                    preserveScroll: true,
                    onError: () => vm.saving = false,
                    onSuccess: () => vm.saving = false,
                })

            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },
        async updateBlog() {
            this.saving = true;
            try {
                const formData = new FormData();

                let updatedData = {
                    title: this.post.title,
                    metaTitle: this.post.metaTitle,
                    metaDescription: this.post.metaDescription,
                    content: this.post.content,
                    type: this.post.type
                }

                Object.keys(updatedData).forEach(blog => formData.append(blog, updatedData[blog]));

                if (this.$refs.blogImage.getFile().source !== this.$refs.blogImage.files) {
                    const uploadedFiles = this.$refs.blogImage.getFiles();
                    uploadedFiles.forEach(file => formData.append('image', file.file));
                }

                this.$inertia.post(route('cms.blogs.update', this.post.id), formData)
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },
    },
    mounted() {
        if (this.isEditing) {
            this.post = this.posts;
            this.post.metaDescription = this.posts.meta_description;
            this.post.metaTitle = this.posts.meta_title;
            this.blogImage = this.posts.image;

            console.log( this.blogImage);
        }
    },
}
</script>
